import React from 'react';
import styled from 'styled-components'
import { CSVLink } from "react-csv";
import arrowRight from '../../assets/arrow-right.svg';
import arrowLeft from '../../assets/arrow-left.svg';
import play from '../../assets/play.svg';
import smallLoader from '../../assets/loader-small.svg';
import loader from '../../assets/loader.svg';
import { baseUrl } from '../url';
import moment from 'moment';
import Modal from '../modal/Modal';
import Video from '../VideoPlayer/Video';

const ExportContainer = styled.div`
  padding: 20px;
  background: #FFFFFF;
  -webkit-box-shadow: 0px 1px 3px rgba(63, 63, 68, 0.15), 0px 0px 0px rgba(63, 63, 68, 0.05);
  box-shadow: 0px 1px 3px rgba(63, 63, 68, 0.15), 0px 0px 0px rgba(63, 63, 68, 0.05);
  border-radius: 0 0 3px 3px;
  border-top: 4px solid #14DA9E;
  margin-bottom: 20px;
`;
const ExportButton = styled.button`
    width: 95%;
    font-size: 14px;
    color: #FFFFFF;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background: #7C74FE;
    border: 2px dashed #6C63FF;
    box-sizing: border-box;
    border-radius: 3px;
    height: 36px;
    margin-top: 20.4px;
    display: flex;
`;

const prettyCSVButton = {
  width: "100%",
  color: "#FFFFFF",
  height: "100%",
  display: "flex",
  marginLeft: "12%"
}

class VotSubmissions extends React.Component{
    state = {
        vots: [],
        date: "2018-07",
        thisMonth: moment().format('YYYY-MM'),
        currentDate: moment().format('YYYY-MM-DD'),
        days: 7,
        response: false,
        show: false,
        loadMore: true,
        startOfMonth: false,
        view: 'today',
        total: 0,
        currentPage: 1,
        more: 0,
        moreResponse: false,
        csvData: []
    }
    componentDidMount(){
        this.fetchVots();
    }
    fetchVots = () => {
        let days = this.state.days - 1;
        let {currentDate, currentPage} = this.state;
        let endDate = '';
        if(this.state.view === "week"){
            let startOfWeek = moment().startOf('week');
            let currDate = moment();
            let diff = currDate.diff(startOfWeek, 'days');
            days = diff - 1;
            endDate = moment(currentDate).subtract({days}, 'days').format('YYYY-MM-DD');
            this.setState({
                response: false
            })
        }else{
            endDate = moment(currentDate).subtract({days}, 'days').format('YYYY-MM-DD');
        }

        let token = localStorage.getItem('access_token'),
            user_id = localStorage.getItem('user_id');
        let retries = 0;
        fetch(`${baseUrl}/admin/patients/${user_id}/vots?end_date=${currentDate}&start_date=${endDate}&page=${currentPage}`,{
            method: 'GET',
            headers: {
                'Authorization': token
            },
        })
        .then((response) => {
            const auth = response.headers.get('Authorization');
            localStorage.setItem('access_token', auth);
            return response.json();
        })
        .then((responseJson) => {
            let vots = [...this.state.vots, ...responseJson.data]
            let csvData = []
            csvData.push(['Submission'])
            vots.forEach(submission => {
              csvData.push([submission.video_url])
            })

            this.setState({
                vots: [...this.state.vots, ...responseJson.data],
                loadMore: true,
                total: responseJson.meta.total,
                totalPages: responseJson.meta.last_page,
                moreResponse: true,
                csvData: csvData
            })
            if(currentPage === 1){
                this.setState({
                    more: responseJson.meta.total - 10,
                    response: true,
                })
            }
        })
        .catch((error)=>{
            if (error === 401 && retries < 1){
                localStorage.getItem('access_token')
                .then(value => {
                    fetch(`${baseUrl}/token/refresh`,{
                        headers: {
                            'Accept': 'application/json',
                            'Authorization': value
                        }
                    }).then(response => {
                        retries += 1;
                        if(response.status === 200){
                            localStorage.setItem('access_token', response.headers.get('Authorization'));
                            this.handleSubmit();
                        }
                        else{
                            alert('something went wrong please try again later');
                        }
                    })
                })
            }
            else{
                alert('something went wrong please try again later');
            }
        })
    }
    incrementMonth = () => {
        let thisMonth =  this.state.thisMonth,
            today = moment(thisMonth),
            lastMonth = today.add(1, 'month').endOf('month');
            if(lastMonth > moment()){
                lastMonth = moment();
            }

        this.setState({
            currentDate: lastMonth.format('YYYY-MM-DD'),
            thisMonth: lastMonth.format('YYYY-MM'),
            response: false,
            days: 7,
            startOfMonth: false,
            currentPage: 1,
            vots: [],
        },this.fetchVots);
    }
    decrementMonth = () => {
        let thisMonth =  this.state.thisMonth,
            today = moment(thisMonth),
            lastMonth = today.subtract(1, 'month').endOf('month');
        this.setState({
            currentDate: lastMonth.format('YYYY-MM-DD'),
            thisMonth: lastMonth.format('YYYY-MM'),
            response: false,
            days: 7,
            startOfMonth: false,
            currentPage: 1,
            vots: [],
        },this.fetchVots);
    }
    loadMore = () => {
        let nextPage = this.state.currentPage + 1;

        if(nextPage <= this.state.totalPages){
            this.setState({
                currentPage: this.state.currentPage + 1,
                more: this.state.more - 10,
                moreResponse: false
            }, () => { this.fetchVots() })
        }
    }
    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value,
        })
    }
    showModal = (id) => {
        this.setState({ videoId: id, show: true });
    }
    hideModal = () => {
        this.setState({ show: false });
    }

    render(){
        const {vots, thisMonth, total, more, moreResponse, response} = this.state;
        let month = moment(thisMonth).format('MMMM YYYY');
        return(
            <div className="vot-submissions">
                <div className="row">
                    <div className="col-sm-8">
                        <div className="month">
                            <div>
                                <button className="button"
                                        onClick={this.decrementMonth}>
                                    <img src={arrowLeft} alt=""/>
                                </button>
                                <input type="month" name="date" value={this.state.thisMonth} onChange={this.handleChange}/>
                                <button className="button"
                                        onClick={this.incrementMonth}
                                        disabled={moment().format('YYYY-MM') === this.state.thisMonth && true}>
                                    <img src={arrowRight} alt=""/>
                                </button>
                            </div>
                            {/* <div>
                                <button className="button all">All</button>
                                <button className="button week deactivated">This week</button>
                            </div> */}
                        </div>
                        {
                            !response &&
                            <div className="loader">
                                <img src={loader} alt=""/>
                            </div>
                        }
                        {
                            response && vots.length === 0 &&
                            <div className="submission-heading">
                                <div className="loader">
                                    <h6>No vots submitted this month.</h6>
                                </div>
                            </div>
                        }
                        {
                            vots.length > 0 &&
                            <React.Fragment>
                                <div className="submission-heading">
                                    <h4>{month}</h4>
                                    <h5>{total} VOT Submissions</h5>
                                </div>
                                <table>
                                    <tbody>
                                        {
                                            vots.map(vot => {
                                                const { id, status, treatment_time } = vot;
                                                let date = moment(treatment_time).format('dddd MMMM D, YYYY - h:mmA')
                                                let approvalClass = "";
                                                status === "unapproved" && (approvalClass = "dis-approved")
                                                status === "approved" && (approvalClass = "approved")
                                                status === "action_required" && (approvalClass = "pending")

                                                return (
                                                    <tr key={id}>
                                                        <td><div className="play-div" onClick={() => this.showModal(id)}><img src={play} alt="" /></div></td>
                                                        <td className="date-time">{date}</td>
                                                        <td className={approvalClass}>
                                                            {status === "approved" && <i className="fa fa-check"></i>}
                                                            {status === "unapproved" && <i className="fa fa-times"></i>}
                                                            {status === "action_required" && <i className="fa fa-minus"></i>}
                                                            {status === "action_required" ? "Pending" : status}
                                                        </td>
                                                    </tr>
                                                )
                                            })
                                        }
                                    </tbody>
                                </table>
                                <Modal show={this.state.show} handleClose={this.hideModal}>
                                    {this.state.show && <Video videoId={this.state.videoId}/>}
                                </Modal>
                                {
                                    more > 0 &&
                                    <div className="more-div">
                                        {/* <p className="more-text"><i className="fa fa-plus-circle"></i>Load more submissions (13)</p> */}
                                        {
                                            !moreResponse &&
                                            <img src={smallLoader} alt="" />
                                        }
                                        {
                                            moreResponse && more > 0 &&
                                            <p className="more-text" onClick={this.loadMore}>load more submissions({more})</p>
                                        }
                                    </div>
                                }
                            </React.Fragment>
                        }
                    </div>

                    <div className="col-sm-4">
                      <ExportContainer>
                          <h6>Export Users</h6>
                          <ExportButton>
                            <i className="fa fa-download"></i>

                            <CSVLink
                              data={this.state.csvData}
                              filename={"vots_report.csv"}
                              style={prettyCSVButton}
                              >
                              Export User
                            </CSVLink>
                          </ExportButton>
                      </ExportContainer>
                    </div>
                </div>
            </div>
        )
    }
}

export default VotSubmissions;



// WEBPACK FOOTER //
// ./src/components/patientProfile/VotSubmissions.js